(function () {
  'use strict';
  if (window.sgBfHeroBlocks) { window.sgBfHeroBlocks.scan(document); return; }
  var instances = new Map();
  var dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/;
  function dateValue(value) { return dateFormat.test(value || '') ? Date.parse(value) : NaN; }
  function topOffset() {
    var bottom = 0;
    document.querySelectorAll('sticky-header,.shopify-section-header-sticky .header-wrapper,[data-sg-anchor-nav],[data-sticky-header],.shopify-section-group-header-group').forEach(function (node) {
      var box = node.getBoundingClientRect(), style = getComputedStyle(node);
      var active = style.position === 'fixed' || style.position === 'sticky' || node.classList.contains('is-pinned');
      if (active && box.height > 0 && box.bottom > 0 && box.top < 160) bottom = Math.max(bottom, box.bottom);
    });
    var nav = document.querySelector('[data-sg-anchor-shell][data-sticky="true"] [data-sg-anchor-nav]');
    if (nav && !nav.classList.contains('is-pinned')) bottom += nav.getBoundingClientRect().height;
    return bottom;
  }
  function init(root) {
    if (instances.has(root)) return;
    var timers = Array.from(root.querySelectorAll('[data-sg-banner-countdown]'));
    var interval;
    function tick() {
      timers.forEach(function (timer) {
        var data = timer.dataset, start = dateValue(data.start), end = dateValue(data.end);
        var caption = timer.querySelector('[data-sg-countdown-caption]');
        var invalid = timer.parentElement.querySelector('[data-sg-countdown-error]');
        var valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
        timer.hidden = !valid; if (invalid) invalid.hidden = valid; if (!valid) return;
        var now = Date.now(), phase = now < start ? 'before' : now < end ? 'during' : 'ended';
        var remaining = Math.max(0, Math.ceil(((phase === 'before' ? start : end) - now) / 1000));
        var values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
        Object.keys(values).forEach(function (key) { var node = timer.querySelector('[data-sg-time="' + key + '"]'); if (node) node.textContent = String(values[key]).padStart(2, '0'); });
        var label = phase === 'before' ? data.startLabel : phase === 'during' ? data.endLabel : data.endedLabel;
        if (caption) caption.textContent = label; timer.dataset.phase = phase;
        timer.setAttribute('aria-label', label + ': ' + values.days + ' days, ' + values.hours + ' hours, ' + values.minutes + ' minutes, ' + values.seconds + ' seconds');
      });
    }
    function fitText() {
      root.querySelectorAll('.sg-bfb-fit-warning').forEach(function (n) { n.remove(); });
      if (root.hasAttribute('data-sg-anchor-editor')) {
        var canvas = root.getBoundingClientRect();
        root.querySelectorAll('.sg-bfb-legacy').forEach(function (node) {
          var box = node.getBoundingClientRect();
          if (box.bottom > canvas.bottom + 1 || box.top < canvas.top || node.scrollHeight > node.clientHeight + 1) {
            var warning = document.createElement('span'); warning.className = 'sg-bfb-fit-warning'; warning.textContent = '价格补充说明超出画布或本块区域，请增加画布高度或本块高度'; warning.setAttribute('role', 'status'); root.appendChild(warning);
          }
        });
      }
      root.querySelectorAll('[data-sg-banner-fit]').forEach(function (node) {
        node.style.fontSize = '';
        var size = parseFloat(getComputedStyle(node).fontSize), minimum = Math.min(14, size);
        while ((node.scrollHeight > node.clientHeight + 1 || node.scrollWidth > node.clientWidth + 1) && size > minimum) { size -= 1; node.style.fontSize = size + 'px'; }
        if (root.hasAttribute('data-sg-anchor-editor') && (node.scrollHeight > node.clientHeight + 1 || node.scrollWidth > node.clientWidth + 1)) {
          var warning = document.createElement('span'); warning.className = 'sg-bfb-fit-warning'; warning.textContent = '内容超出固定区域，请增加本块高度或精简文案'; warning.setAttribute('role', 'status'); node.parentElement.appendChild(warning);
        }
      });
    }
    function navigate(event) {
      var link = event.target.closest('[data-sg-banner-link]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      var url = new URL(link.href, location.href);
      if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
      var target;
      try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_) { return; }
      if (!target) return;
      event.preventDefault();
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - topOffset() - 16), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.pushState(null, '', url.hash);
      var focusNode = target.querySelector('h1,h2,h3') || target, priorTabIndex = focusNode.getAttribute('tabindex');
      focusNode.setAttribute('tabindex', '-1'); focusNode.focus({ preventScroll: true });
      if (priorTabIndex === null) focusNode.addEventListener('blur', function () { focusNode.removeAttribute('tabindex'); }, { once: true });
    }
    tick();
    if (timers.length) interval = window.setInterval(tick, 1000);
    fitText();
    var observer = 'ResizeObserver' in window ? new ResizeObserver(fitText) : null;
    if (observer) observer.observe(root); else window.addEventListener('resize', fitText);
    if (document.fonts) document.fonts.ready.then(function () { if (root.isConnected) fitText(); });
    root.addEventListener('click', navigate);
    instances.set(root, function () { clearInterval(interval); if (observer) observer.disconnect(); window.removeEventListener('resize', fitText); root.removeEventListener('click', navigate); });
  }
  function scan(scope) { if (scope.matches && scope.matches('[data-sg-bf-block-banner]')) init(scope); scope.querySelectorAll('[data-sg-bf-block-banner]').forEach(init); }
  window.sgBfHeroBlocks = { scan: scan, destroy: function (root) { if (instances.has(root)) { instances.get(root)(); instances.delete(root); } }, instanceCount: function () { return instances.size; } };
  document.addEventListener('shopify:block:select', function(event) { var banner = event.target.closest('[data-sg-bf-block-banner]'); if (banner) { window.sgBfHeroBlocks.destroy(banner); scan(banner); } });
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { instances.forEach(function (destroy, root) { if (event.target.contains(root)) { destroy(); instances.delete(root); } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
})();
